export const FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_REQUEST';
export const FORGOT_PASSWORD_REQUEST_SUCCESS = 'FORGOT_PASSWORD_REQUEST_SUCCESS';
export const FORGOT_PASSWORD_REQUEST_ERROR = 'FORGOT_PASSWORD_REQUEST_ERROR';

export const REDIRECT_PAGE_FROM_FORGOT_PASSWORD = 'REDIRECT_PAGE_FROM_FORGOT_PASSWORD';

export const CLEAR_DATA_FORGOT_PASSWORD = 'CLEAR_DATA_FORGOT_PASSWORD';